import React from 'react';
import { Icon } from './Icon.js';
export const IconHouseBolt2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M11.2363 12H16.2363L13.2363 18H11L13 14H8L11 8H13.2363L11.2363 12Z", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("path", { d: "M12 2L2 9.5V10.5L4 11V21H20V11L22 10.5V9.5L12 2Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconHouseBolt2.js.map